import { getProspectiveSeoSubCategoryAPI, getProspectiveSeoSubSubCategoryAPI, getSeoSubCategoryAPI, getSeoSubSubCategoryAPI } from "../api/SubCategoryApi";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    seoSubCategory: {},
    seoSubSubCategory: {},
    prospectiveSeoSubCategory: {},
    prospectiveSeoSubSubCategory: {},
    loading: false,
    successful: false,
    status: ''
}

// seo get Call
export const getSeoSubCategoryData = createAsyncThunk(
    "blog/getSeoSubCategoryData",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getSeoSubCategoryAPI(payload);
            return response?.data;
        } catch (err) {
            return rejectWithValue({
                errorMessage: err?.message,
            });
        }
    }
);

export const getSeoSubSubCategoryData = createAsyncThunk(
    "blog/getSeoSubSubCategoryData",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getSeoSubSubCategoryAPI(payload);
            return response?.data;
        } catch (err) {
            return rejectWithValue({
                errorMessage: err?.message,
            });
        }
    }
);

// prospective seo get Call
export const getProspectiveSeoSubCategoryData = createAsyncThunk(
    "blog/getProspectiveSeoSubCategoryData",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getProspectiveSeoSubCategoryAPI(payload);
            return response?.data;
        } catch (err) {
            return rejectWithValue({
                errorMessage: err?.message,
            });
        }
    }
);

export const getProspectiveSeoSubSubCategoryData = createAsyncThunk(
    "blog/getProspectiveSeoSubSubCategoryData",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getProspectiveSeoSubSubCategoryAPI(payload);
            return response?.data;
        } catch (err) {
            return rejectWithValue({
                errorMessage: err?.message,
            });
        }
    }
);

const subCategorySlice = createSlice({
    name: "subCategory",
    initialState,
    extraReducers: (builder) => {
        // get Seo Sub Category
        builder.addCase(getSeoSubCategoryData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getSeoSubCategoryData.fulfilled, (state, action) => {
            state.seoSubCategory = action?.payload;
            state.successful = false;
            state.loading = false;
        });
        builder.addCase(getSeoSubCategoryData.rejected, (state) => {
            state.loading = true;
        });

        // get Seo Sub Sub Category
        builder.addCase(getSeoSubSubCategoryData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getSeoSubSubCategoryData.fulfilled, (state, action) => {
            state.seoSubSubCategory = action?.payload;
            state.successful = false;
            state.loading = false;
        });
        builder.addCase(getSeoSubSubCategoryData.rejected, (state) => {
            state.loading = true;
        });


        // get Prospective Seo Sub Category
        builder.addCase(getProspectiveSeoSubCategoryData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getProspectiveSeoSubCategoryData.fulfilled, (state, action) => {
            state.prospectiveSeoSubCategory = action?.payload;
            state.successful = false;
            state.loading = false;
        });
        builder.addCase(getProspectiveSeoSubCategoryData.rejected, (state) => {
            state.loading = true;
        });

        // get Prospective Seo Sub Category
        builder.addCase(getProspectiveSeoSubSubCategoryData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getProspectiveSeoSubSubCategoryData.fulfilled, (state, action) => {
            state.prospectiveSeoSubSubCategory = action?.payload;
            state.successful = false;
            state.loading = false;
        });
        builder.addCase(getProspectiveSeoSubSubCategoryData.rejected, (state) => {
            state.loading = true;
        });
    },
});

export default subCategorySlice.reducer;